// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__PKfhH","footer":"ReportModalFilter_footer__qev6X"};